import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const TYPES = [
  {
    text: "SageMaker Pipeline",
    value: "sagemaker_pipeline",
  },
];

const NotebookPanel = ({ notebookJobState, setNotebookJobState }) => {
  const { type, jobPipeline, pipelineList } = useMemo(() => notebookJobState, [notebookJobState]);

  return (
    <Grid container>
      <Grid container direction={"row"} spacing={2} sx={{ mb: "16px" }}>
        <Grid
          size={{
            xs: 6,
            md: 4
          }}>
          <TextField
            select
            required
            fullWidth
            variant="outlined"
            label="Type"
            value={type}
            onChange={(e) => setNotebookJobState((prev) => ({ ...prev, type: e.target.value }))}
          >
            {TYPES.map((p) => (
              <MenuItem key={p.value} value={p.value}>
                {p.text}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid
        sx={{ paddingTop: "2px !important" }}
        size={{
          sm: 12,
          md: 8
        }}>
        <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel>Target</InputLabel>
          <Select
            label="Target"
            required
            fullWidth
            variant="outlined"
            value={jobPipeline}
            onChange={(e) => setNotebookJobState((prev) => ({ ...prev, jobPipeline: e.target.value }))}
            MenuProps={{ sx: { maxHeight: "400px", maxWidth: "700px" } }}
          >
            {pipelineList.map((p) => (
              <MenuItem
                key={p.value}
                value={p.value}
                sx={{ whiteSpace: "normal", wordWrap: "break-word", wordBreak: "break-all" }}
              >
                {p.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

NotebookPanel.propTypes = {
  notebookJobState: PropTypes.object.isRequired,
  setNotebookJobState: PropTypes.func.isRequired,
};

export default React.memo(NotebookPanel);
